import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'carbon-checkbox-group',
  templateUrl: './carbon-checkbox-group.component.html',
  styleUrls: ['./carbon-checkbox-group.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CarbonCheckboxGroupComponent),
      multi: true
    }
  ]
})
export class CarbonCheckboxGroupComponent implements OnInit, ControlValueAccessor {
  @Input() label!: string;
  @Input() name: string = 'checkbox-group';
  @Input() readonly: boolean;
  @Input() required = false;
  @Input() options: { val: any; label: string; tooltip?: string }[] = [];
  @Input() showFieldSet: boolean = false;
  @Output() valueChange = new EventEmitter<any[]>();
  @Input() control!: FormControl;
  @Input() hidden: boolean = false;
  @Input() orientation: 'vertical' | 'horizontal' = 'vertical';

  value: any[] = [];
  disabled = false;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor() { }

  ngOnInit() {
  }

  get class(): string {
    if(this.showFieldSet == true) {
      return 'conditional-section show';
    }else{
      return '';
    }
  }

  writeValue(value: any): void {
    this.value = value || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  isChecked(val: any): boolean {
    return this.value && this.value.indexOf(val) > -1;
  }

  toggleValue(val: any) {
    if (this.disabled || this.readonly) return;

    const index = this.value.indexOf(val);
    if (index > -1) {
      this.value.splice(index, 1);
    } else {
      this.value.push(val);
    }

    this.onChange(this.value);
    this.onTouched();
    this.valueChange.emit(this.value);
  }
}
